import { COLORS } from 'helpers/globals'

export default {
  details: {
    paddingTop: '.5rem',
    display: 'flex',
    flexDirection: 'column',
    color: 'black',
    fontSize: '2rem',
    fontWeight: 400,
    height: '95%'
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flex: '1 1 auto'
  },
  device: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 1rem',
    '&:nth-of-type(odd)': {
      background: COLORS.tertiary
    }
  },
  wiredDeviceIcon: {
    borderRadius: '50%',
    color: 'white',
    flex: '0 1 3.5rem',
    height: '3.5rem',
    display: 'flex',
    margin: '0 1.25rem 0 .25rem',
    fontSize: '1.6rem'
  },
  distanceText: {
    fontSize: '1.8rem',
    fontWeight: 300
  },
  wireLengthWarning: {
    fontSize: '1.5rem',
    fontWeight: 300,
    padding: '0 1rem',
    '& svg': {
      marginRight: '.5rem',
      color: COLORS.warning
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/NetworkClosetDetails/exportStyle.js